// extracted by mini-css-extract-plugin
export default {"c4c":"_27xHJl2fDVWcD9Ih_YHY6Z","box":"_2R-q24hFQ5aFGrm7WCEwgn","steps":"_2pUkl8xgAVQDBMP_WtqZl2"};